var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-sidesheet",
    {
      attrs: { id: "type-modal", active: _vm.displayModal },
      on: { close: _vm.close },
    },
    [
      _c("m-confirm", { ref: "confirm", attrs: { mode: "danger" } }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingData,
              expression: "!isLoadingData",
            },
          ],
          staticClass: "modal-frame",
        },
        [
          _c(
            "div",
            { staticClass: "modal-wrapper" },
            [
              _c(
                "shadow-scroll-container",
                {
                  ref: "track",
                  staticClass: "modal-track",
                  attrs: { "with-top-scroller": true },
                },
                [
                  _c("div", { staticClass: "modal-frame__header" }, [
                    _c("h2", { staticClass: "modal-frame__title" }, [
                      _vm._v("Новая проводка"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "form-group" },
                    [
                      _c("c-switcher", {
                        staticClass: "h-switcher",
                        attrs: {
                          type: "group",
                          items: _vm.transactionTypes.types,
                        },
                        model: {
                          value: _vm.transactionTypes.selectedType,
                          callback: function ($$v) {
                            _vm.$set(_vm.transactionTypes, "selectedType", $$v)
                          },
                          expression: "transactionTypes.selectedType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "form-group__column" },
                      [
                        _c("c-select-2", {
                          staticClass: "modal-frame__transaction-type",
                          attrs: {
                            type: "select",
                            "floating-label": "Тип проводки",
                            clearable: true,
                            searchable: true,
                            items: _vm.transactionTypes.items,
                            "use-custom-colors": true,
                            required:
                              _vm.isSubmitted && _vm.transactionTypesError,
                            "required-message":
                              _vm.isSubmitted && _vm.transactionTypesError,
                            "required-mark": true,
                          },
                          model: {
                            value: _vm.transactionTypes.selectedItem,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.transactionTypes,
                                "selectedItem",
                                $$v
                              )
                            },
                            expression: "transactionTypes.selectedItem",
                          },
                        }),
                        _vm.transactionTypes.selectedItem &&
                        _vm.transactionTypes.selectedItem.description
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "click blur",
                                    boundary: "window",
                                    content:
                                      _vm.transactionTypes.selectedItem
                                        .description,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: transactionTypes.selectedItem.description,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "form-group__item-description form-group__item-description--desktop",
                              attrs: { size: "iconic", icon: "info-new" },
                            })
                          : _vm._e(),
                        _vm.transactionTypes.selectedItem &&
                        _vm.transactionTypes.selectedItem.description
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "click blur",
                                    boundary: "window",
                                    content:
                                      _vm.transactionTypes.selectedItem
                                        .description,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: transactionTypes.selectedItem.description,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "form-group__item-description form-group__item-description--mobile",
                              attrs: {
                                icon: "info-new",
                                label: "Показать описание",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _vm.balances.worker_id
                    ? _c("div", { staticClass: "form-group" }, [
                        _c("div", { staticClass: "form-group__column" }, [
                          _c(
                            "div",
                            { staticClass: "form-group__item-balances" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form-group__item-balances-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group__item-balances-item-header",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group__item-balances-item-number",
                                          class: {
                                            positive:
                                              _vm.balances.personal_amount > 0,
                                            negative:
                                              _vm.balances.personal_amount < 0,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.balances.personal_amount
                                                )
                                              ) +
                                              " " +
                                              _vm._s(_vm.currencyLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("c-button", {
                                        directives: [
                                          {
                                            name: "b-popover",
                                            rawName: "v-b-popover.html",
                                            value: {
                                              container: "#app",
                                              trigger: "hover click blur",
                                              boundary: "window",
                                              content: _vm.filialsWithBalances,
                                              placement: "top",
                                            },
                                            expression:
                                              "{\n                      container: '#app',\n                      trigger: 'hover click blur',\n                      boundary: 'window',\n                      content: filialsWithBalances,\n                      placement: 'top',\n                    }",
                                            modifiers: { html: true },
                                          },
                                        ],
                                        staticClass:
                                          "form-group__balances-description",
                                        attrs: {
                                          size: "iconic",
                                          icon: "info-new",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group__item-balances-item-name",
                                    },
                                    [_vm._v("Личный счет")]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group__item-balances-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group__item-balances-item-header",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group__item-balances-item-number",
                                          class: {
                                            positive:
                                              _vm.balances.deposit_amount > 0,
                                            negative:
                                              _vm.balances.deposit_amount < 0,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.balances.deposit_amount
                                                )
                                              ) +
                                              " " +
                                              _vm._s(_vm.currencyLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group__item-balances-item-name",
                                    },
                                    [_vm._v("Депозит")]
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass: "form-group__item-balances-item",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group__item-balances-item-header",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form-group__item-balances-item-number",
                                          class: {
                                            positive:
                                              _vm.balances.accountable_amount >
                                              0,
                                            negative:
                                              _vm.balances.accountable_amount <
                                              0,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatNumber(
                                                  _vm.balances
                                                    .accountable_amount
                                                )
                                              ) +
                                              " " +
                                              _vm._s(_vm.currencyLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "form-group__item-balances-item-name",
                                    },
                                    [_vm._v("Подотчет")]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group__column form-group__column--2",
                      },
                      [
                        !_vm.transactionTypes.selectedItem
                          ? _c("c-input", {
                              staticClass: "modal-frame__transaction-type",
                              attrs: {
                                type: "select",
                                "floating-label": "Филиал",
                                disabled: !_vm.transactionTypes.selectedItem,
                              },
                              model: {
                                value: _vm.filials.selectedFilial,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filials, "selectedFilial", $$v)
                                },
                                expression: "filials.selectedFilial",
                              },
                            })
                          : _c("c-select-2", {
                              attrs: {
                                type: "select",
                                "floating-label": "Филиал",
                                clearable: !_vm.isFilialRequired,
                                searchable: true,
                                items: _vm.filials.allFilials,
                                "use-custom-colors": true,
                                required: _vm.isSubmitted && _vm.filialError,
                                "required-message":
                                  _vm.isSubmitted && _vm.filialError,
                                "required-mark": _vm.isFilialRequired,
                                disabled: !_vm.transactionTypes.selectedItem,
                              },
                              model: {
                                value: _vm.filials.selectedFilial,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filials, "selectedFilial", $$v)
                                },
                                expression: "filials.selectedFilial",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "form-group__column form-group__column--2",
                      },
                      [
                        !_vm.transactionTypes.selectedItem
                          ? _c("c-input", {
                              staticClass: "modal-frame__transaction-type",
                              attrs: {
                                type: "select",
                                "floating-label": "Должность",
                                disabled: !_vm.transactionTypes.selectedItem,
                              },
                              model: {
                                value: _vm.posts.selectedPost,
                                callback: function ($$v) {
                                  _vm.$set(_vm.posts, "selectedPost", $$v)
                                },
                                expression: "posts.selectedPost",
                              },
                            })
                          : _c("c-select-2", {
                              staticClass: "modal-frame__filial",
                              attrs: {
                                type: "select",
                                "floating-label": "Должность",
                                clearable: !_vm.isPostCodeRequired,
                                searchable: true,
                                items: _vm.posts.allPosts,
                                "use-custom-colors": true,
                                required: _vm.isSubmitted && _vm.postError,
                                "required-message":
                                  _vm.isSubmitted && _vm.postError,
                                "required-mark": _vm.isPostCodeRequired,
                                disabled: !_vm.transactionTypes.selectedItem,
                              },
                              model: {
                                value: _vm.posts.selectedPost,
                                callback: function ($$v) {
                                  _vm.$set(_vm.posts, "selectedPost", $$v)
                                },
                                expression: "posts.selectedPost",
                              },
                            }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "form-group__column" },
                      [
                        _c("c-input", {
                          staticClass: "modal-frame__transaction-type",
                          class: {
                            "is-invalid":
                              _vm.isSubmitted && _vm.transactionReasonsError,
                          },
                          attrs: {
                            type: "select",
                            "floating-label": _vm.transactionReason,
                            clearable: true,
                            searchable: true,
                            items: _vm.transactionReasons.items,
                            "use-custom-colors": true,
                            required:
                              _vm.isSubmitted && _vm.transactionReasonsError,
                            "required-condition":
                              _vm.isSubmitted && _vm.transactionReasonsError,
                            "required-mark": true,
                            disabled: !_vm.transactionTypes.selectedItem,
                          },
                          model: {
                            value: _vm.transactionReasons.selectedReason,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.transactionReasons,
                                "selectedReason",
                                $$v
                              )
                            },
                            expression: "transactionReasons.selectedReason",
                          },
                        }),
                        _vm.transactionReasons.selectedReason &&
                        _vm.transactionReasons.selectedReason.subLabel
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "click blur",
                                    boundary: "window",
                                    content:
                                      _vm.transactionReasons.selectedReason
                                        .subLabel,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: transactionReasons.selectedReason.subLabel,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "form-group__item-description form-group__item-description--desktop",
                              attrs: { size: "iconic", icon: "info-new" },
                            })
                          : _vm._e(),
                        _vm.transactionReasons.selectedReason &&
                        _vm.transactionReasons.selectedReason.subLabel
                          ? _c("c-button", {
                              directives: [
                                {
                                  name: "b-popover",
                                  rawName: "v-b-popover.html",
                                  value: {
                                    container: "#app",
                                    trigger: "click blur",
                                    boundary: "window",
                                    content:
                                      _vm.transactionReasons.selectedReason
                                        .subLabel,
                                    placement: "top",
                                  },
                                  expression:
                                    "{\n                container: '#app',\n                trigger: 'click blur',\n                boundary: 'window',\n                content: transactionReasons.selectedReason.subLabel,\n                placement: 'top',\n              }",
                                  modifiers: { html: true },
                                },
                              ],
                              staticClass:
                                "form-group__item-description form-group__item-description--mobile",
                              attrs: {
                                icon: "info-new",
                                label: "Показать описание",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      {
                        staticClass: "form-group__column form-group__column--3",
                      },
                      [
                        _c("c-input", {
                          attrs: {
                            type: "price-number",
                            label: "Сумма, ฿",
                            placeholder: "0",
                            "max-length": 12,
                            clearable: true,
                            required:
                              _vm.isSubmitted && _vm.transactionAmountError,
                            "required-message":
                              _vm.isSubmitted && _vm.transactionAmountError,
                            "input-text-condition":
                              _vm.isSubmitted && _vm.transactionAmountError,
                            "required-mark": true,
                          },
                          model: {
                            value: _vm.transactionAmount,
                            callback: function ($$v) {
                              _vm.transactionAmount = $$v
                            },
                            expression: "transactionAmount",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "form-group__column form-group__column--3",
                      },
                      [
                        _c("c-input", {
                          ref: "dateInput",
                          attrs: {
                            label: "Дата учетная",
                            editable: true,
                            clearable: true,
                            type: "date",
                            format: "DD.MM.YYYY, dddd",
                            icon: "calendar",
                            placeholder: "00.00.0000",
                            required:
                              _vm.isSubmitted && _vm.transactionDate.error,
                            "required-message":
                              _vm.isSubmitted && _vm.transactionDate.error,
                            "required-mark": true,
                            "icon-right": true,
                          },
                          on: { invalidDate: _vm.sendErrorDateMessage },
                          model: {
                            value: _vm.transactionDate.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.transactionDate, "value", $$v)
                            },
                            expression: "transactionDate.value",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "form-group__column" },
                      [
                        _c("c-select-2", {
                          attrs: {
                            type: "select",
                            "floating-label": "Кто принял решение",
                            clearable: true,
                            searchable: true,
                            items: _vm.workersList.items,
                          },
                          model: {
                            value: _vm.workersList.selectedWorker,
                            callback: function ($$v) {
                              _vm.$set(_vm.workersList, "selectedWorker", $$v)
                            },
                            expression: "workersList.selectedWorker",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "form-group__column" },
                      [
                        _c("c-select-2", {
                          staticClass: "modal-frame__transaction-type",
                          attrs: {
                            type: "select",
                            "floating-label": "Юр. лицо",
                            clearable: true,
                            searchable: true,
                            items: _vm.companies.items,
                            "use-custom-colors": true,
                            required: _vm.isSubmitted && _vm.companiesError,
                            "required-message":
                              _vm.isSubmitted && _vm.companiesError,
                            "required-mark": true,
                          },
                          model: {
                            value: _vm.companies.selectedCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.companies, "selectedCompany", $$v)
                            },
                            expression: "companies.selectedCompany",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      { staticClass: "form-group__column" },
                      [
                        _c("c-input", {
                          ref: "comment2",
                          attrs: {
                            type: "textarea",
                            "floating-label": "Комментарий",
                            clearable: true,
                            "max-length": "255",
                          },
                          model: {
                            value: _vm.comment,
                            callback: function ($$v) {
                              _vm.comment = $$v
                            },
                            expression: "comment",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "modal-frame__actions" },
                    [
                      _c("c-button", {
                        staticClass: "modal-frame__action",
                        attrs: { label: "Отменить", size: "large" },
                        on: { click: _vm.close },
                      }),
                      _c("c-button", {
                        staticClass: "modal-frame__action",
                        attrs: {
                          label: "Сохранить",
                          size: "large",
                          color: "primary",
                          disabled: _vm.blocked,
                        },
                        on: { click: _vm.submit },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "modal-actions" },
            [
              _c("c-button", {
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: { label: "Сохранить", color: "primary", size: "large" },
                on: { click: _vm.submit },
              }),
            ],
            1
          ),
        ]
      ),
      _vm.isLoadingData
        ? _c("c-loader", {
            attrs: {
              label: "Данные загружаются",
              active: _vm.isLoadingData,
              height: "400",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }